import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { environment } from '../../../environments/environment';
import { ICustomComponent } from '../../shared/interfaces/database/configuracion';

@Injectable({
  providedIn: 'root'
})
export class CustomComponentService {
  private readonly baseUrl = `${environment.apiUrl}/api/custom-components`;

  constructor(private readonly http: HttpClient) { }

  getAll(): Observable<ICustomComponent[]> {
    return this.http.get<ICustomComponent[]>(`${this.baseUrl}/get-components`);
  }
}
